import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { captureEvent, isPostHogEnabled } from '../posthog'

/** Manual $pageview for React Router (autocapture pageviews are disabled). */
export function PostHogPageview() {
  const location = useLocation()

  useEffect(() => {
    if (!isPostHogEnabled()) {
      return
    }
    captureEvent('$pageview')
  }, [location.pathname, location.search])

  return null
}
